import { render, staticRenderFns } from "./SlotsLocation.vue?vue&type=template&id=15c7da70&scoped=true&lang=pug&"
import script from "./SlotsLocation.vue?vue&type=script&lang=js&"
export * from "./SlotsLocation.vue?vue&type=script&lang=js&"
import style0 from "./SlotsLocation.vue?vue&type=style&index=0&id=15c7da70&lang=scss&scoped=true&"
import style1 from "./SlotsLocation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c7da70",
  null
  
)

export default component.exports